
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import React from 'react';

interface NeonBadgeProps {
  text: string;
  primaryColor?: string;
}

export const NeonBadge: React.FC<NeonBadgeProps> = ({
  text,
  primaryColor = '#FF4081', // default color
}) => {
  return (
    <span
      css={css({
        display: 'inline-block',
        padding: '6px 14px',
        borderRadius: '9999px',
        background: primaryColor,
        color: '#fff',
        fontWeight: 600,
        textShadow: `0 0 8px ${primaryColor}`,
        boxShadow: `0 0 12px ${primaryColor}55`,
        letterSpacing: '0.5px',
        transition: 'transform 0.2s ease',
        cursor: 'default',
        '&:hover': {
          transform: 'scale(1.05)',
        },
      })}
    >
      {text}
    </span>
  );
};
